(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('policy', {
            parent: 'app',
            url: '/policy?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy/policies.html',
                    controller: 'PolicyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                	var searchParam = $stateParams.search ? JSON.parse($stateParams.search) : {};
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: searchParam
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('policy-detail', {
            parent: 'policy',
            url: '/policy/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy/policy-detail.html',
                    controller: 'PolicyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Policy', function($stateParams, Policy) {
                    return Policy.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'policy',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('policy-detail.edit', {
            parent: 'policy-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy.new', {
            parent: 'policy',
            url: '/new',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                policyXACML: null,
                                priority: null,
                                id: null,
                                isActive: 0,
                                flInserimentoGuidato:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('policy');
                });
            }]
        })
        .state('policy.test', {
            parent: 'policy',
            url: '/test',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/test-policy-dialog.html',
                    controller: 'TestPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('policy');
                });
            }]
        })
        .state('policy.edit', {
            parent: 'policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-dialog.html',
                    controller: 'PolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy.delete', {
            parent: 'policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy/policy-delete-dialog.html',
                    controller: 'PolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Policy', function(Policy) {
                            return Policy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy', null, { reload: 'policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
